export const CALENDAR_LAYOUT = {
  /** Exposed as the `--test-drive-vehicle-column-width` custom property. */
  VEHICLE_COLUMN_WIDTH: 240,
  VEHICLE_COLUMN_WIDTH_MOBILE: 132,
  HOUR_COLUMN_WIDTH: 64,
  /** Day columns stretch to fill the container above this and only scroll below it. */
  DAY_COLUMN_MIN_WIDTH: 34,
  VEHICLE_CELL_PADDING: 4,
  /** Exact fit for the label (4 + 20 + 2 x 16 + 4) — rows cannot grow to their content. */
  MIN_ROW_HEIGHT: 60,
  ROW_LANE_HEIGHT: 26,
  BAR_VERTICAL_GAP: 4,
  ROW_VERTICAL_PADDING: 8,
  HEADER_HOUR_HEIGHT: 20,
  /** In `theme.getSize` steps (44px). */
  SLOT_ADD_HIT_AREA: 11,
  SLOT_OVERLAY_Z_INDEX: 1,
  STICKY_COLUMN_Z_INDEX: 2,
  STICKY_HEADER_Z_INDEX: 3,
  STICKY_CORNER_Z_INDEX: 4,
} as const;
